// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__79jF5","errorLogs":"styles_errorLogs__H-VJc"};